"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _find = _interopRequireDefault(require("./find"));
var _search = _interopRequireDefault(require("./search"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = {
  find: _find["default"],
  search: _search["default"]
};
module.exports = exports["default"];